import styles from "./ResponseStepField.module.scss";

export interface ResponseStepFieldProps {
  title: string;
  value: any;
  applyBackground: boolean;
  isV2?: boolean;
}

const ResponseStepField = ({
  title,
  value,
  applyBackground,
  isV2 = false,
}: ResponseStepFieldProps) => {
  //dd-privacy attribute to mask responses for Datadog RUM
  return (
    <div
      data-dd-privacy="mask"
      key={title}
      className={isV2 ? `pv-2 ph-3 ${styles.v2Field}` : "pv-1 pl-2"}
      style={{
        backgroundColor: applyBackground && !isV2 ? "#f0f5f5" : "",
        borderBottom: isV2 ? "1px solid #e5e7eb" : "",
      }}
    >
      <p className="mb-0 fwb f-1 fwt lh-1" style={{ color: "gray" }}>
        {title}
      </p>
      <p className={`mb-0 lh-2`}>{value}</p>
    </div>
  );
};

export default ResponseStepField;
